import _ from 'underscore';

import { Messages } from '../../codegen/Localize';
import { Formatters} from '../../codegen/Localize';
import { simpleActionErrorMsg,simpleActionSuccessMsg } from '../../commonInfra/contentActions/ActionHelpers';
import { ContentActionNotification } from '../../commonInfra/contentActions/ContentActionNotification';
import { openReactActionDialog } from '../../commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import { ExtractTasks } from '../../extract/resources/ExtractTasks';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { L10n } from '../../ts/L10n/L10n';
import { IExtractTaskInfo } from '../../ts/models/IExtractTaskInfo';
import { Set } from '../../ts/models/Set';
import { ChangePriorityDialogBody,ChangePriorityDialogProps, ChangePriorityDialogState } from '../components/ReactInputNumberDialog';

function execute(extractTasks: Set<IExtractTaskInfo>): Promise<IResult> {
  let dialogDescription: string;
  let numberDescription: string;
  let currentPriority: number;
  const extractTaskCount = extractTasks.size();
  if(extractTaskCount === 1) {
    const extractTask = extractTasks.first();
    if(extractTask.workbook){
      dialogDescription = Messages.extractTasksSetPriorityWorkbookPrompt({PARENT_NAME: L10n.elideIfLong(extractTask.workbook.name)});
    }
    else if(extractTask.datasource){
      dialogDescription = Messages.extractTasksSetPriorityDatasourcePrompt({PARENT_NAME: L10n.elideIfLong(extractTask.datasource.name)});
    }
  }
  else {
    dialogDescription = Messages.extractTasksSetPriorityMultiplePrompt({ITEM_COUNT_LOC: Formatters.formatCount(extractTaskCount)});
  }

  numberDescription = Messages.createScheduleFormPriorityDescription();
  currentPriority = Math.min(..._.map(extractTasks.toArray(), (extractTasks: IExtractTaskInfo) => extractTasks.priority));

  const dialogConfig = openReactActionDialog<ChangePriorityDialogProps,ChangePriorityDialogState,IResult>({
    actionName: Messages.tasksSetPriorityConfirm({ITEM_COUNT: extractTaskCount,ITEM_COUNT_LOC: Formatters.formatCount(extractTaskCount)}),
    bodyComponent: ChangePriorityDialogBody,
    initialDialogState: {
      text: currentPriority,
      errorMessage: undefined
    },
    initialBodyProps: {
      title: Messages.tasksSetPriority(),
      description: dialogDescription,
      numberDescription: numberDescription,
      min: ExtractTasks.MIN_PRIORITY,
      max: ExtractTasks.MAX_PRIORITY,
      isInteger: true
    },
    action:(_bodyProps: ChangePriorityDialogProps,dialogState: ChangePriorityDialogState) => ExtractTasks.setPriority(extractTasks.keys(), dialogState.text),
    dialogWidth: TabDialogWidth.width500px,
    dismissDialogOnActionFailed: false,
  });

  dialogConfig.result.then((result: IResult) => {
    ContentActionNotification.displaySingleToastForResult({
      items: extractTasks,
      errors: result.errors,
      successMsg: simpleActionSuccessMsg(Messages.extractTasksSetPrioritySuccess),
      errorMsg: simpleActionErrorMsg(Messages.extractTasksSetPriorityError),
    });
  });

  return Promise.resolve(dialogConfig.result);
}

export const ChangeExtractTaskPriorityAction = {
  execute
};
export type ChangeExtractTaskPriorityAction = typeof ChangeExtractTaskPriorityAction;
